import { render, staticRenderFns } from "./shiftManagementSettings.vue?vue&type=template&id=1ae320f2&scoped=true"
import script from "./shiftManagementSettings.vue?vue&type=script&lang=js"
export * from "./shiftManagementSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae320f2",
  null
  
)

export default component.exports